import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { LoadingCircle } from '../../../../../src/components/common/loading';
import ScrollableLayout from '../../../../../src/components/common/scrollable-layout';
import SortingHeader from '../../../../../src/components/common/sorting-header';
import Header from '../../../../../src/screens/maturities-assets/header';
import Transaction from './transaction';
import TransactionDetails from '../../../../../src/screens/maturities-assets/transaction-details';
import AssetAccordion from '../../../../../src/components/common/asset-accordion/asset-accordion.container';
import Error from '../../../../../src/components/common/error';

export default function maturitiesAssetsFactory({
  assetCategory,

  HeaderComponent = Header,
  SortingHeaderComponent = SortingHeader,
  RowComponent = Transaction,
  ExpandedRowComponent = TransactionDetails,
}) {
  class MaturitiesAssets extends PureComponent {
    componentDidMount() {
      const { detailTitle } = this.props.maturities;
      this.props.maturities.setDetailTitle(detailTitle);
    }
    componentWillUnmount() {
      this.props.maturities.setDetailTitle("");
    }
    render() {
      const { portfolio, maturities, ui, app, screen, i18n: { messages } } = this.props;
      let uiStatic, maxChars;
      if (!screen.isSmall) {
        uiStatic = ui.static[assetCategory].maturitiesAssetsTablet;
        maxChars = null;
      } else {
        uiStatic = ui.static[assetCategory].maturitiesAssets;
        maxChars = 30;
      }
      const uiState = ui.state.maturitiesAssets;
      const { detailMarketValue, assetsSorted } = maturities;

      if (!screen.isSmall) {
        assetsSorted.map(row =>
          row.canExpand = false
        );
      } else {
        assetsSorted.map(row =>
          row.canExpand = (uiStatic.detailsGroups && uiStatic.detailsGroups.length > 0)
          || (row.name && row.name.length > maxChars)
        );
      }

      const bodyView = (
        <AssetAccordion
          uiStatic={uiStatic}
          state={uiState}
          rows={assetsSorted}
          messages={messages}
          renderRow={row => <RowComponent
            row={row}
            uiStatic={uiStatic}
            descriptionMaxChars={maxChars}
            deviceInfo={app.global.deviceInfo}
            screen={screen}
            messages={messages}
          />}
          renderRowExpanded={(row) => <ExpandedRowComponent
            row={row}
            detailsGroups={uiStatic.detailsGroups}
            abbreviationRules={ui.static.abbreviationRules}
            descriptionMaxChars={maxChars}
            referenceCurrency={portfolio.referenceCurrency}
            headerGroup={uiStatic.options}
            messages={messages}
          />}
        />
      );
      return (
        <div className={'position-transactions row'}>
          <div className="small-12 small-centered medium-12 medium-centered large-12 large-centered">
            <ScrollableLayout
              testID={`maturities-assets-${assetCategory}`}
              header={<HeaderComponent
                marketValue={detailMarketValue}
                currency={portfolio.referenceCurrency}
                messages={messages}
                location = {ui.history.currentLocation.pathname} />}
              stickyHeader={<SortingHeaderComponent
                headerStyle={{textAlign: 'center'}}
                options={uiStatic.options}
                currency={portfolio.referenceCurrency}
                state={uiState}
                messages={messages}
              />}
              body={bodyView}
            />
          </div>
        </div>
      );
    }
  }

  return createContainer({
    $renderError: () => <Error />,
    $renderLoading: () => <LoadingCircle isPage={true} />,
    $queries: {
      app: {
        global: {
          deviceInfo: {
            isTablet: true
          }
        }
      },
      i18n: {
        messages: true,
      },
      screen: {
        height: true,
        width: true,
        isSmall: true,
      },
      portfolio: {
        referenceCurrency: true,
      },
      maturities: {
        detailMarketValue: true,
        assetsSorted: true,
        detailTitle: true,
        setDetailTitle: { $call: 'customTitle' },
      },
      ui: {
        history: {
          currentLocation: {
            pathname: true
          }
        },
        static: {
          [assetCategory]: {
            maturitiesAssets: {
              ...AssetAccordion.getFragment('uiStatic'),
              ...RowComponent.getFragment('uiStatic'),
              detailsGroups: true,
              options: true,
            },
            maturitiesAssetsTablet: {
              ...AssetAccordion.getFragment('uiStatic'),
              ...RowComponent.getFragment('uiStatic'),
              detailsGroups: true,
              options: true,
            },
          },
          abbreviationRules: true,
        },

        state: {
          maturitiesAssets: {
            selectedKey: true,
            ascending: true,
            onOptionSelect: { $call: 'changeSort' },
            resetSort: { $call: 'resetSort' },
            ...AssetAccordion.getFragment('state'),
          },
        },
      },
    },
  })(MaturitiesAssets);
}